module.exports = __webpack_public_path__ + "img/logo4.092e0ab2.png";